import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import PieceDetail from "@/pages/PieceDetail";
import Admin from "@/pages/Admin";
import { ContentProvider } from "@/lib/content";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            border: "1px solid #e5e1d8",
            background: "#ffffff",
            color: "#000000",
          },
        }}
      />
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/piece/:id" element={<PieceDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
